type SkillCardProps = {
  language: string
  problemsSolved: number
  timeSpent: number
}

function SkillCard({ language, problemsSolved, timeSpent }: SkillCardProps) {
  return (
    <div className="bg-purple-50 rounded-lg p-4 flex justify-between items-center">
      <div>
        <h3 className="font-medium text-lg">{language}</h3>
        <div className="grid grid-cols-2 gap-x-8 mt-2">
          <div>
            <p className="text-sm text-gray-500">Problems Solved</p>
            <p className="font-medium">{problemsSolved}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Time spent practicing</p>
            <p className="font-medium">{timeSpent} mins</p>
          </div>
        </div>
      </div>
      <div className="flex-shrink-0">
        <div className="bg-amber-100 rounded-full p-2 w-12 h-12 flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-amber-500"
          >
            <circle cx="12" cy="8" r="7"></circle>
            <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
          </svg>
        </div>
        <p className="text-center text-xs mt-1">Level</p>
      </div>
    </div>
  )
}

export default function ProgrammingSkills() {
  return (
    <section className="px-6 pb-6">
      <div className="flex items-center gap-2 mb-4">
        <div className="bg-purple-100 p-1 rounded-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-purple-500"
          >
            <polyline points="16 18 22 12 16 6"></polyline>
            <polyline points="8 6 2 12 8 18"></polyline>
          </svg>
        </div>
        <h2 className="font-medium">Programming Skills</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <SkillCard language="C++" problemsSolved={927} timeSpent={3159} />
        <SkillCard language="C++" problemsSolved={927} timeSpent={3159} />
        <SkillCard language="C++" problemsSolved={927} timeSpent={3159} />
      </div>
    </section>
  )
}

